const SELECTORS = {
  email: '[data-qa="email"], [data-qa="email"] input',
  password: '[data-qa="password"], [data-qa="password"] input',
  firstName: '[data-qa="first-name"], [data-qa="first-name"] input',
  lastName: '[data-qa="last-name"], [data-qa="last-name"] input',
  phone: '[data-qa="phone-number"], [data-qa="phone-number"] input',
  dobDay: '[data-qa="date-of-birth-day"], [data-qa="date-of-birth-day"] input',
  dobMonth:
    '[data-qa="date-of-birth-month"], [data-qa="date-of-birth-month"] input',
  dobYear:
    '[data-qa="date-of-birth-year"], [data-qa="date-of-birth-year"] input',
}

const find = (selector) => document.querySelector(selector)

const fireEvents = (element) => {
  element.dispatchEvent(new Event('input', { bubbles: true }))
  element.dispatchEvent(new Event('change', { bubbles: true }))
}

const setValue = (element, value) => {
  if (!element || !value) return
  element.value = value
  fireEvents(element)
}

const setChecked = (element) => {
  if (!element || element.checked) return
  element.checked = true
  fireEvents(element)
}

const resolveEmail = (email) => {
  if (!email || email.includes('+')) return email
  const atIndex = email.indexOf('@')
  if (atIndex === -1) return email
  const suffix = Math.random().toString(36).slice(2, 8)
  return `${email.slice(0, atIndex)}+${suffix}${email.slice(atIndex)}`
}

export const submitForm = () => {
  const button =
    find('button[data-qa="submit"]') ?? find('button[type="submit"]')
  if (button && !button.disabled) {
    button.scrollIntoView({ behavior: 'smooth', block: 'center' })
    button.click()
  }
}

export const fillForm = (fields) => {
  const [dobYear = '', dobMonth = '', dobDay = ''] = (fields.dob || '').split(
    '-',
  )

  setValue(find(SELECTORS.email), resolveEmail(fields.email))
  setValue(find(SELECTORS.password), fields.password)
  setValue(find(SELECTORS.firstName), fields.firstName)
  setValue(find(SELECTORS.lastName), fields.lastName)
  setValue(find(SELECTORS.phone), fields.phone)
  setValue(find(SELECTORS.dobDay), dobDay)
  setValue(find(SELECTORS.dobMonth), dobMonth)
  setValue(find(SELECTORS.dobYear), dobYear)
  document.querySelectorAll('input[type="checkbox"]').forEach(setChecked)
}
